import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageCircle, Send } from "lucide-react";

export default function MobileStickyBar() {
  const { pathname } = useLocation();
  // Hide on contact page (already has prominent form/CTAs)
  if (pathname.startsWith("/contatti")) return null;

  return (
    <div
      className="lg:hidden fixed bottom-3 inset-x-3 z-40 rounded-2xl bg-white border border-brand-line shadow-2xl p-2 flex gap-2"
      data-testid="mobile-sticky-bar"
    >
      <a
        href="https://wa.me/393465726648?text=Ciao,%20vorrei%20info%20sui%20corsi%20del%20Polo%20ECP%20Profili"
        target="_blank"
        rel="noreferrer"
        className="flex-1 inline-flex items-center justify-center gap-1.5 bg-brand-whatsapp text-white font-bold text-sm py-3 rounded-xl"
        data-testid="mobile-bar-whatsapp"
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
      <Link
        to="/contatti"
        className="flex-1 inline-flex items-center justify-center gap-1.5 bg-brand-emerald text-white font-bold text-sm py-3 rounded-xl"
        data-testid="mobile-bar-iscriviti"
      >
        <Send className="w-4 h-4" /> Iscriviti
      </Link>
    </div>
  );
}
